var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8694 9.6875C11.1741 9.6875 11.4319 9.94531 11.4319 10.25C11.4319 10.5781 11.1741 10.8125 10.8694 10.8125C10.5413 10.8125 10.3069 10.5781 10.3069 10.25C10.3069 9.94531 10.5413 9.6875 10.8694 9.6875ZM11.6194 7.625C12.6506 7.625 13.4944 8.46875 13.4944 9.5V12.5C13.4944 12.7109 13.3069 12.875 13.1194 12.875H11.6194V15.125C11.6194 15.3359 11.4319 15.5 11.2444 15.5H3.74438C3.53345 15.5 3.36938 15.3359 3.36938 15.125V12.875H1.86938C1.65845 12.875 1.49438 12.7109 1.49438 12.5V9.5C1.49438 8.46875 2.3147 7.625 3.36938 7.625V4.25C3.36938 3.85156 3.67407 3.5 4.07251 3.5H9.27563C9.55688 3.5 9.86157 3.64062 10.0725 3.85156L11.2678 5.04688C11.4788 5.25781 11.6194 5.5625 11.6194 5.84375V7.625ZM4.49438 4.625V7.625H10.4944V6.125H9.36938C9.15845 6.125 8.99438 5.96094 8.99438 5.75V4.625H4.49438ZM10.4944 14.375V12.875H4.49438V14.375H10.4944ZM12.3694 11.75V9.5C12.3694 9.10156 12.0178 8.75 11.6194 8.75H3.36938C2.94751 8.75 2.61938 9.10156 2.61938 9.5V11.75H12.3694Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePlus);
export default __webpack_public_path__ + "static/media/file-plus.9bb75f6d10ec77d23a47953e76841002.svg";
export { ForwardRef as ReactComponent };